import { useParams } from "react-router-dom";
import { ArchiveStatus } from "../../domains/Attendance";

type ArchiveStatusParameter = "archived" | undefined;
export const useArchiveStatusParameter = (): ArchiveStatus | null => {
  const params = useParams<{ archiveStatus: ArchiveStatusParameter }>();
  if (params.archiveStatus === undefined) {
    return ArchiveStatus.active;
  }
  return params.archiveStatus === "archived" ? ArchiveStatus.archived : null;
};
